<template>
    <div>
        <div class="col-sm-12 bt-footer">
            <div>
                <div class="bt-footer-content">
                    <div class="col-sm-4 col-xs-4">
                        <h4>Brabant Tools BV</h4>
                        <div>Draaiboom 51</div>
                        <div>5094 CB Lage Mierde (NL)</div>
                        <div>Tel.: +31 (0)497-701301</div>
                        <div>Mob.: +31 (0)6-13053051</div>
                        <div>
                            E-mail:
                            <a href="mailto:info@brabanttools.nl" title="info@brabanttools.nl">info@brabanttools.nl</a>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xs-4" v-if="!$can('btonly') && !$can('customer')">
                        <div class="row">
                            <div class="col-sm-12">
                                <h5 class="pull-right"><strong>{{$t("login")}}</strong></h5>
                            </div>
                        </div>
                        <div>
                            <form class="form-horizontal" @submit.prevent="login()">
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">{{$t("email")}}:</label>
                                    <div class="col-sm-8">
                                        <input type="email" v-model="customer.email" class="form-control" id="email" :placeholder="$t('email')" required>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="pwd">{{$t("password")}}:</label>
                                    <div class="col-sm-8">
                                        <input type="password" v-model="customer.password" class="form-control" id="pwd" :placeholder="$t('password')" required>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-offset-4 col-sm-4">
                                        <button type="submit" class="btn btn-danger">{{$t("login")}}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xs-4" style="margin-top: 30px;" v-if="$can('btonly') || $can('customer')">
                        <h3>{{$t("welcome")}} {{loggedInCustomer.name}}!</h3>
                        <div>
                            <button type="button" class="btn btn-danger" @click="logout()">{{$t("logout")}}</button>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xs-4">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import * as types from '../store/mutation-types'

    export default {
        name: 'BtFooter',
        data() {
            return {
                customer: { email: '', password: '' }
            }
        },
        methods: {
            login() {
                this.$store.dispatch('login', this.customer).then(() => {
                    if (this.loggedInCustomer.id) {
                        if (this.loggedInCustomer.email === 'info@brabanttools.nl') {
                            this.access = 'btonly'
                            this.$store.commit(types.SET_ADMIN, true)
                        } else {
                            this.access = 'customer'
                            this.$store.commit(types.SET_ADMIN, false)
                        }
                        this.$store.dispatch('getShoppingCart').then(() => {
                            if (this.productsInShoppingCart.length > 0) {
                                this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id).then(() => {
                                    this.$store.dispatch('getDiscounts').then(() => {
                                        this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART, this.discounts)
                                        this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                            if (this.customerSpecificPrices) {
                                                this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART, this.customerSpecificPrices)
                                            }
                                        })
                                        if (this.products) {
                                            this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                                            this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                                if (this.customerSpecificPrices) {
                                                    this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                                                }
                                            })
                                        }
                                    })
                                })
                            }
                        })
                    }
                    if (!this.isLoggedIn) {
                        this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Deze gegevens zijn bij ons niet bekend!' })
                    }
                })
            },
            logout() {
                this.access = 'public'
                this.$store.commit(types.SET_ADMIN, false)
                this.$store.dispatch('logout')
            }
        },
        computed: {
            ...mapGetters({
                loggedInCustomer: 'loggedInCustomer',
                productsInShoppingCart: 'productsInShoppingCart',
                customerSpecificPrices: 'customerSpecificPrices',
                discounts: 'discounts',
                products: 'products',
                isLoggedIn: 'isLoggedIn'
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
